import React from 'react'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@mui/material'
import LightMode from './theme/theme'
import { getLibrary } from './web3/connectors'
import { Web3ReactProvider } from '@web3-react/core'
import { QueryClientProvider, QueryClient } from 'react-query'
import { RefreshControllerProvider } from './contexts/refresh-controller'
import ReactDOM from 'react-dom'

const queryClient = new QueryClient()

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={LightMode}>
      <Web3ReactProvider getLibrary={getLibrary}>
        <QueryClientProvider client={queryClient}>
          <RefreshControllerProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </RefreshControllerProvider>
        </QueryClientProvider>
      </Web3ReactProvider>

    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')

)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
